import axios from "axios";

// All admin-UI traffic goes to the same origin (Caddy fronts it). The
// `withCredentials` flag tells axios to send the audra_session cookie on
// cross-origin requests — important in local dev where the proxy effectively
// re-origins us.
export const api = axios.create({
  baseURL: "/",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// On 401, redirect to the SSO login. The `return_to` param brings the user
// back to wherever they were after the Entra round-trip.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const returnTo = window.location.pathname + window.location.search;
      window.location.href = `/auth/entra/login?return_to=${encodeURIComponent(returnTo)}`;
    }
    return Promise.reject(error);
  },
);
